module.exports = __webpack_public_path__ + "static/img/ushenina.b5d2315.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/ushenina.jpg
// module id = 509
// module chunks = 11